function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.678 2.765a2.319 2.319 0 013.442 0l1.667 1.789c.95 1.02.95 2.674 0 3.693l-5.934 6.374a1.149 1.149 0 01-1.706 0L1.213 8.247c-.95-1.02-.95-2.673 0-3.693l1.667-1.79a2.319 2.319 0 013.442 0L8 4.566l1.678-1.8z",
  fill: "currentColor"
})));